import { FC } from 'react';
import { DesignConflictSection } from '../types';
import { DesignConflictItemContainer } from './design-conflict-item-container';
import { DesignConflictSubsectionContainer } from './design-conflict-subsection-container';

export interface DesignConflictSectionContainerProps {
  section: DesignConflictSection;
}

export const DesignConflictSectionContainer: FC<(
  DesignConflictSectionContainerProps
)> = ({
  section
}) => {
  return (
    <div className="panel no-border">
      <h4>{section.label}</h4>
      {('items' in section) ? (
        section.items.map((item) => {
          return (
            <DesignConflictItemContainer
              key={item.key}
              item={item}
            />
          );
        })
      ) : (
        section.subsections.map((subsection) => {
          return (
            <DesignConflictSubsectionContainer
              key={subsection.label}
              subsection={subsection}
            />
          );
        })
      )}
    </div>
  );
};
